export const ENV = {
  STAGING: "https://wc26.demosoftfruit.com/",
  PRODUCTION: "https://worldcup.mediaoneonline.com/",
  DEV: "http://localhost:3000/"
}

export const WEB_URL = ENV.STAGING